import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { ContentInfusionRawData, ContentInfusionState, FormattedInfusionData } from './types';
import { ContentInfusionActionsType, fetchContentInfusionsActions } from './actions';

const mapInfusionData = (data: ContentInfusionRawData): FormattedInfusionData => {
    if (data && data.items && data.content_infusion_main_title) {
        const infusionItems = data.items.map(item => ({
            itemImage: item.content_infusion_item_image,
            itemLink: item.content_infusion_item_link,
            itemPreTitle: item.content_infusion_item_pre_title || '',
            itemTopicTitle: item.content_infusion_item_topic_title,
            itemCtaText: item.content_infusion_item_cta_text,
        }));

        return {
            mainTitle: data.content_infusion_main_title,
            items: infusionItems,
        };
    }

    return {};
};

const defaultInfusionState = {
    isFetching: false,
    didInvalidate: false,
    identifier: '',
};

const infusionReducer = createReducer<ContentInfusionState, ContentInfusionActionsType>(defaultInfusionState)
    .handleAction(fetchContentInfusionsActions.success, (state, action) => {
        return {
            ...state,
            infusion: mapInfusionData(action.payload.data.data),
            isFetching: false,
        };
    })
    .handleAction(fetchContentInfusionsActions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(fetchContentInfusionsActions.request, (state, action) => defaultRequestHandler(state, action));

export default infusionReducer;
